/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReadingCircledIcon = /*#__PURE__*/ createSvgIcon(
  'ReadingCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M6.77 12.5c.49 0 .967.055 1.43.164.464.11.925.274 1.383.492V7a5.353 5.353 0 00-1.36-.563 5.734 5.734 0 00-2.57-.078c-.37.073-.726.183-1.07.329v6.187a7.095 7.095 0 011.086-.281c.36-.063.727-.094 1.102-.094zm4.063.656c.459-.219.92-.383 1.383-.492a6.417 6.417 0 012.531-.07c.36.062.722.156 1.086.281V6.687a5.417 5.417 0 00-1.07-.328 5.76 5.76 0 00-2.57.079c-.48.125-.933.312-1.36.562v6.156zm-.625 1.516c-.146 0-.284-.018-.414-.055a1.75 1.75 0 01-.367-.148 5.112 5.112 0 00-1.281-.54 5.299 5.299 0 00-1.375-.179c-.438 0-.867.057-1.29.172a5.653 5.653 0 00-1.21.484.602.602 0 01-.633-.015.604.604 0 01-.305-.547V6.313c0-.115.029-.224.086-.329a.54.54 0 01.258-.234c.48-.25.98-.438 1.5-.563A6.805 6.805 0 016.771 5a6.739 6.739 0 013.438.938A6.737 6.737 0 0113.645 5c.541 0 1.073.063 1.593.188.521.125 1.021.312 1.5.562.115.052.201.13.258.234a.671.671 0 01.086.329v7.53c0 .24-.101.423-.304.548a.602.602 0 01-.633.015 5.655 5.655 0 00-1.211-.484 4.896 4.896 0 00-1.29-.172c-.468 0-.926.06-1.374.18-.448.12-.875.3-1.282.539a1.751 1.751 0 01-.367.148c-.13.037-.268.055-.414.055z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default ReadingCircledIcon;
